import React from 'react'

import {
    BomTextField,
    BomRadioGroup,
    BomSelect,

    // BomGglPlacesSearch,
} from '../data/controlsArray.js'
import appUtilities from '../utilities/appUtilities.js'
import CorrectCopyright from '../components/CorrectCopyright.js'

const sxPropArray = {
    radio_w_tooltip: { mt: { xs: 0.75, sm: 2.5 } },
    // radio_1: { py: { xs: 0, md: 2.04 } },
    // radio_2: { py: { xs: 0, md: 0 } },
    // radio_only: { py: { xs: 0, md: 2.47 } },
}
// const sxPropArray = {
//     radio_none: {},
//     radio_1: {},
//     radio_2: {},
//     radio_only: {},
// }

const formFields = Object.freeze({
    GglMap: [],

    2: [
        {
            labelRow: 'Select the UNIT of measure',
            id: 'measure',
            label: 'Units',
            name: 'unit',
            paramKey: 'unit',

            type: 'text',
            sxProp: sxPropArray['radio_none'],

            autoFocusFlag: true,
            displayValueArray: appUtilities.getMeasureDisplayArray,
            selectInputArray: appUtilities.getMeasureValueArray,
            control: BomSelect,
        },
        {
            labelRow: 'Enter the fence length',
            id: 'fence-size',
            label: 'Length',
            name: 'size',
            paramKey: 'size',

            type: 'number',
            sxProp: sxPropArray['radio_none'],
            autoFocusFlag: false,
            control: BomTextField,
        },
    ],
    3: [
        {
            labelRow: 'Choose the number of STRANDS for your fence',
            id: 'strands',
            label: 'Strands',
            name: 'strands',
            paramKey: 'strands',
            helpTitle: 'Strand Number',
            helpTxt: `We suggest setting your top
                strand at withers height (or at least shoulder height) of your tallest horse and the bottom
                strand somewhere between hock and fetlock based on your specific needs or preference.
                You should then install the balance of the strands by spacing them equally. For safety we recommend 4 strands for horse enclosures. `,
            helpLink: ``,

            type: 'text',
            sxProp: sxPropArray['radio_none'],

            autoFocusFlag: true,
            displayValueArray: appUtilities.getStrandDisplayArray,
            selectInputArray: appUtilities.getStrandValueArray,
            control: BomSelect,
        },
        {
            labelRow: 'Select your choice of braid color',
            id: 'color',
            label: 'Color',
            name: 'color',
            paramKey: 'color',

            type: 'text',
            sxProp: sxPropArray['radio_none'],

            autoFocusFlag: false,
            displayValueArray: appUtilities.getColorDisplayArray,
            selectInputArray: appUtilities.getColorValueArray,
            control: BomSelect,
        },
    ],
    4: [
        {
            labelRow: 'Enter SPACING between posts',
            id: 'spacing',
            label: 'Spacing',
            name: 'spacing',
            paramKey: 'spacing',
            helpTitle: 'Post Spacing',
            helpTxt: `lf the land is flat with no winter conditions we recommend a spacing of up to 35 ft. (10 m.) &mylinebrk If its hilly or subject to winter conditions, we recommend a 25 ft. (8 m.) maximum`,
            helpLink: `/manual#c`,
            type: 'text',
            sxProp: sxPropArray['radio_1'],

            autoFocusFlag: true,
            displayValueArray: appUtilities.getSpacingDisplayArray,
            selectInputArray: appUtilities.getSpacingValueArray,
            control: BomSelect,
        },
        {
            labelRow: 'Select your line post material',
            id: 'p_mats',
            name: 'p_mats',
            paramKey: 'p_mats',

            type: 'text',
            sxProp: sxPropArray['radio_1'],

            autoFocusFlag: false,
            displayValueArray: ['Wood/Pipe', 'Tree', 'T-Post'],
            selectInputArray: ['0', '1', '2'],
            control: BomRadioGroup,
        },
    ],
    5: [
        {
            labelRow: 'Enter the number of CORNERS',
            id: 'corners',
            label: 'Corners',
            name: 'corners',
            paramKey: 'corners',
            helpTitle: 'Corners',
            helpTxt:
                'Any change in direction greater than 20 degrees will require a corner post',
            helpLink: `/manual#g`,

            type: 'text',
            sxProp: sxPropArray['radio_2'],

            autoFocusFlag: true,
            displayValueArray: appUtilities.getCornerDisplayArray,
            selectInputArray: appUtilities.getCornerValueArray,
            control: BomSelect,
        },
        {
            labelRow: 'Select your corner post material',
            id: 'c_mats',
            name: 'c_mats',
            paramKey: 'c_mats',

            type: 'text',
            sxProp: sxPropArray['radio_2'],

            autoFocusFlag: false,
            displayValueArray: ['Wood/Pipe', 'Tree'],
            selectInputArray: ['0', '1'],
            control: BomRadioGroup,
        },
        {
            labelRow: `Select diagonal used in corner post 'H-brace'`,
            id: 'c_hbrace',
            name: 'c_hbrace',
            paramKey: 'c_hbrace',
            helpTitle: 'Bracing',
            helpTxt:
                'The diagonal supports the posts to prevent tipping from fence tension.',
            helpLink: `/manual#gb`,
            type: 'text',
            sxProp: sxPropArray['radio_w_tooltip'],

            autoFocusFlag: false,
            displayValueArray: ['Braid', 'Wood', 'None'],
            selectInputArray: ['0', '1', '2'],
            control: BomRadioGroup,
        },
    ],
    6: [
        {
            labelRow: 'Enter the number of GATES',
            id: 'gates',
            label: 'Gates',
            name: 'gates',
            paramKey: 'gates',
            helpTitle: 'Gates',
            helpTxt:
                'The hardware needed for two ends will be included for each gate defined here. See the next page to add the other end types. (ie. ends in use in a split paddock or terminations at a barn).',
            helpLink: ``,

            type: 'text',
            sxProp: sxPropArray['radio_w_tooltip'],

            autoFocusFlag: true,
            displayValueArray: appUtilities.getGateDisplayArray,
            selectInputArray: appUtilities.getGateValueArray,
            control: BomSelect,
        },
        {
            labelRow: 'Select your gate post material',
            id: 'g_mats',
            name: 'g_mats',
            paramKey: 'g_mats',

            type: 'text',
            sxProp: sxPropArray['radio_2'],

            autoFocusFlag: false,
            displayValueArray: ['Wood/Pipe', 'Tree'],
            selectInputArray: ['0', '1'],
            control: BomRadioGroup,
        },
        {
            labelRow: `Select diagonal used in gate post 'H-brace'`,
            id: 'g_hbrace',
            name: 'g_hbrace',
            paramKey: 'g_hbrace',
            helpTitle: 'Bracing',
            helpTxt:
                'The diagonal supports the posts to prevent tipping from fence tension.',
            helpLink: `/manual#gb`,
            type: 'text',
            sxProp: sxPropArray['radio_w_tooltip'],

            autoFocusFlag: false,
            displayValueArray: ['Braid', 'Wood', 'None'],
            selectInputArray: ['0', '1', '2'],
            control: BomRadioGroup,
        },
    ],
    7: [
        {
            labelRow: 'Enter the number of ENDS',
            id: 'ends',
            label: 'Ends',
            name: 'ends',
            paramKey: 'ends',
            helpTitle: 'Ends',
            helpTxt: `Define the ends that are used in a split paddock or terminations at a barn. The ends for any gates you've selected have been included.`,
            helpLink: ``,
            type: 'text',
            sxProp: sxPropArray['radio_2'],

            autoFocusFlag: true,
            displayValueArray: appUtilities.getEndDisplayArray,
            selectInputArray: appUtilities.getEndValueArray,
            control: BomSelect,
        },
        {
            labelRow: 'Select your end post material',
            id: 'e_mats',
            name: 'e_mats',
            paramKey: 'e_mats',

            type: 'text',
            sxProp: sxPropArray['radio_2'],

            autoFocusFlag: false,
            displayValueArray: ['Wood/Pipe', 'Tree'],
            selectInputArray: ['0', '1'],
            control: BomRadioGroup,
        },
        {
            labelRow: `Select diagonal used in end post 'H-brace'`,
            id: 'e_hbrace',
            name: 'e_hbrace',
            paramKey: 'e_hbrace',
            helpTitle: 'Bracing',
            helpTxt:
                'The diagonal supports the posts to prevent tipping from fence tension.',
            helpLink: `/manual#gb`,
            type: 'text',
            sxProp: sxPropArray['radio_2'],

            autoFocusFlag: false,
            displayValueArray: ['Braid', 'Wood', 'None'],
            selectInputArray: ['0', '1', '2'],
            control: BomRadioGroup,
        },
    ],
    8: [
        {
            labelRow: (
                <CorrectCopyright
                    copyrightTextValue={`Include ElectroBraid Gate® Kits for your gates?`}
                />
            ),
            id: 'kit',
            name: 'kit',
            paramKey: 'kit',

            type: 'text',
            sxProp: sxPropArray['radio_only'],

            autoFocusFlag: true,
            displayValueArray: ['No', 'Yes'],
            selectInputArray: ['0', '1'],
            control: BomRadioGroup,
        },
        // {
        //     labelRow: 'Select your insulator color',
        //     id: 'i_color',
        //     name: 'i_color',
        //     paramKey: 'i_color',

        //     type: 'text',
        //     sxProp: sxPropArray['radio_only'],

        //     autoFocusFlag: false,
        //     displayValueArray: ['Black', 'White'],
        //     selectInputArray: ['0', '1'],
        //     control: BomRadioGroup,
        // },
    ],
})

export default formFields
